module.exports = __webpack_public_path__ + "media/images/icons/remove-activity-icon-4198fc314ecedeb4e90245164e03609e.svg";